export const isStringFalse = (value) => {
    if (!value) return true;
    const falseValues = ["0", "false", ""];
    return falseValues.includes(value.toLowerCase().trim());
};